// This requires a disabled attribute as the first element in the select
// -- Otherwise, the placeholder won't be loaded correctly
// -- Solved, for example, in Lohm Rate calculator by having the disabled category "Liquids" starting the
// -- the fluid type dropdown
$(document).on('change', '.select-wrap select', function(){
	if( $(this).is('[data-select-redirect]') ) {
		window.location.href = $(this).val();
	} else {
		$(this).closest('.select-wrap').find('.placeholder').html( $(this).find('option[value="' + $(this).val() + '"]').text() );
	}
});

$(document).on('click', '[data-filter-collapse-toggle]', function(e){
	e.preventDefault();
	$(this).closest('.filter-outer-wrapper').toggleClass('mobile-collapsed');
	$(window).trigger('resize');
	setTimeout(function(){
		$(window).trigger('resize');
	}, 500);
})

$('[data-filter-wrapper][data-filter-collapse-mobile-filters]').on('click', '[data-switch-filter="filters"]', function(){
	var $parent = $(this).closest('[data-filter-wrapper]')
	if( $parent.find('[data-filter-mobile-collapse]').is(':visible') ) {
		$parent.find('[data-filter-mobile-collapse]').slideUp('slow', function(){
			setTimeout(function(){
				$(window).trigger('resize');
			}, 200)
		});
	} else {
		$parent.find('[data-filter-mobile-collapse]').slideDown('slow', function(){
			setTimeout(function(){
				$(window).trigger('resize');
			}, 200)
		});
	}
})

// Attachment-specific titles based on product type chosen- ie "Installation Procedures for Fill and Drain Valves".
var update_attachment_title = function( $elem ){
	var $appendTitle = $elem.find('.append-installation-procedures-filter');
	if( $elem.is('[data-filter-type="attachment"]') && $appendTitle.length > 0 ) {
		var productTypeVal = $elem.find('[name="product_types"]').val();
		if( ! productTypeVal || productTypeVal == -1 ) {
			$appendTitle.html('');
		} else {
			var selectedFilter = $elem.find('[name="product_types"] option[value="' + productTypeVal + '"]').html();
			if( selectedFilter ) {
				$appendTitle.html(' for ' + selectedFilter);
			}
		}
	}
}

var filter_areas = [];
$('[data-filter-wrapper]').each(function(){
	var $this = $(this);
	
	$this.find('select').each(function(){
		if( $(this).closest('.select-wrap').length == 0 ) {
			$(this).wrap('<div class="select-wrap"></div>');
		};
		if( $(this).closest('.select-wrap').find('.placeholder').length == 0 ) {
			$(this).closest('.select-wrap').prepend('<div class="placeholder">' + $(this).find('option[value="' + $(this).val() + '"]').text() + '</div>');
		}
	});
	
	$this.on('change', 'select', function(e){
		e.preventDefault();
		set_dataLayer({
			'event' 	: 'ui',
			'category'	: 'filter',
			'action'	: 'change',
			'label'		: $(this).attr('data-ui-element'),
			'filter'	: $(this).find('option[value="' + $(this).val() + '"]').text()
		});
		$this.attr('data-filter-offset', 0);
		$this.submit_filter_form();
	});

	$this.on('submit', '[data-filter-search]', function(e){
		e.preventDefault();
		$this.attr('data-filter-offset', 0);
		$this.submit_filter_form();
	});
	$this.on('submit', '[data-filter-search]', function(e){
		e.preventDefault();
		$this.attr('data-filter-offset', 0);
		$this.submit_filter_form();
	});
	
	$this.on('click', '[data-switch-filter]', function(e){
		e.preventDefault();
		$this.attr('data-filter-display', $(this).attr('data-switch-filter'));
	});
	
	$this.on('click', '[data-filter-read-more]', function(e){
		e.preventDefault();
		set_dataLayer({
			'event' 	: 'ui',
			'category'	: 'filter',
			'action'	: 'click',
			'label'		: 'load more'
		});
		$this.attr('data-filter-offset', parseInt( $this.attr('data-filter-offset') ) + parseInt( $this.attr('data-filter-count')));
		$this.submit_filter_form( true );
	});

	$this.on('click', '[data-clear-filters]', function(e){
		e.preventDefault();
		$this.find('select').each(function(){
			$(this).val('-1').closest('.select-wrap').find('.placeholder').html( $(this).find('option[value="' + $(this).val() + '"]').text() );
		});
		set_dataLayer({
			'event' 	: 'ui',
			'category'	: 'filter',
			'action'	: 'click',
			'label'		: $(this).attr('data-ui-element')
		});
		$this.find('[name="search"]').val('').trigger('change');
		$this.submit_filter_form( false );
	});

	update_attachment_title( $this );
});


$.fn.submit_filter_form = function(read_more) {
	read_more = ! read_more ? 0 : 1;

	var $this = $(this);

	var url = $this.attr('data-filter-base-url');
	var url_segments = [];
	var has_filters = 0;

	var ajax_data = {
		lang			: $this.attr('data-filter-lang'),
		offset			: $this.attr('data-filter-offset'),
		post_type		: $this.attr('data-filter-type'),
		action			: $this.attr('data-filter-action'),
		count			: $this.attr('data-filter-count'),
		wrapper_class	: $this.attr('data-filter-wrapper-class'),
	};

	if( $this.attr('data-filter-display') == 'filters' ) {
		ajax_data.filters = {};

		$this.find('select').each(function(){
			if( $(this).val() != -1 ) {
				ajax_data.filters[$(this).attr('name')] = $(this).val();
				url_segments.push( 'filters[' + $(this).attr('name') + ']=' + $(this).val() );
				has_filters = 1;
			};
		});
		
		if( $this.attr('data-default-industry') ) {
			ajax_data.filters.industries = $this.attr('data-default-industry');
		}
		if( $this.attr('data-default-insight_type') ) {
			ajax_data.filters.insight_type = $this.attr('data-default-insight_type').split('|');
		}
		if( $this.attr('data-default-insight_category') ) {
			ajax_data.filters.insight_category = $this.attr('data-default-insight_category').split('|');
		}
		
	} else if( $this.attr('data-filter-display') == 'search' ) {
		ajax_data.search = $this.find('[name="search"]').val();
		url_segments.push( 'search=' + $this.find('[name="search"]').val() );
		has_filters = 1;
	};

	$this.attr('data-filter-status', 'loading');

	update_attachment_title( $this )

	$.ajax({
		url		: '/wp-admin/admin-ajax.php',
		type	: 'GET',
		data	: ajax_data,
		success	: function(result){
			if( result ) {
				if( read_more ) {
					$this.attr('data-filter-status', '').find('[data-filter-content] [data-filter-read-more]').parent().remove();
					$this.attr('data-filter-status', '').find('[data-filter-content]').append(result);
				} else {
					$this.attr('data-filter-status', '').find('[data-filter-content]').html(result);
				}
				get_new_lazy_elems();
				$(document).trigger('scroll');
				setTimeout(function(){
					$(window).trigger('resize');
				}, 50);
			} else {
				$this.attr('data-filter-status', 'no-results');
			}
			if( url_segments.length > 0 ) {
				url += '?' + url_segments.join('&');
			}
			$this.attr('data-has-filters', has_filters);
			window.history.pushState( '', '', url );
		}
	})
}
